// Dynamic Diesels — Shop by Vehicle mobile scroll pager.
// Keeps the dot pager in sync with the horizontal scroll position; tapping
// a dot smooth-scrolls to that card. Only relevant on mobile where the grid
// switches to a horizontal scroller; on desktop the scroller isn't scrollable
// and dots stay hidden via CSS.

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.dd-svs').forEach((section) => {
      const scroller = section.querySelector('.dd-svs__grid');
      const dots = section.querySelectorAll('.dd-svs__dot');
      if (!scroller || !dots.length) return;
      const cards = scroller.querySelectorAll('.dd-truck');
      if (!cards.length) return;

      const setActive = (index) => {
        dots.forEach((dot, i) => {
          const on = i === index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const currentIndex = () => {
        const style = getComputedStyle(scroller);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        const step = cards[0].offsetWidth + gap;
        if (!step) return 0;
        return Math.min(cards.length - 1, Math.max(0, Math.round(scroller.scrollLeft / step)));
      };

      scroller.addEventListener('scroll', () => setActive(currentIndex()), { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const target = cards[index];
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });

      setActive(currentIndex());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
